import React, { Fragment } from 'react'
import { RadioGroup } from 'informed'
import Divider from 'components/Divider'

import { Select, Radio } from 'components/forms'
import { listCashRegisters } from 'gql/query'

export default ({ t }) => {
	return(
		<Fragment>
			<Divider visible height={20}/>
			<RadioGroup field='isActive'>
				<Radio label={t('credit_client_section.strings.all_credit_clients')}/>
				<Radio value={true} label={t('credit_client_section.strings.active_credit_clients')}/>
				<Radio value={false} label={t('credit_client_section.strings.inactive_credit_clients')}/>
			</RadioGroup>
			<Divider visible height={20}/>
			<Select
				field='cashRegisterId'
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				remoteOptions={{
					query: listCashRegisters,
					valueField: 'id',
					labelField: 'name',
					variables: { params: { limit: 100 } }
				}}
				isSearchable
				withVirtualBody
				label={t('credit_client_section.sub_sections.cash_registers')}
				placeholder={t('credit_client_section.strings.select_cash_register')}
			/>
		</Fragment>
	)
}
